import { PriceTagIcon } from "@common/components/icons";
import Modal from "@common/components/Modal";
import { useTranslation, Trans } from "next-i18next";

type Props = {
  promoCode: string;
  isOpen: boolean;
  onClose: () => void;
};

const PromoCodeAppliedModal = ({ promoCode, isOpen, onClose }: Props) => {
  const { t } = useTranslation(["common", "purchase"]);

  return isOpen ? (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("purchase:promo_code_applied")}
      modalType="none"
      alignment="center"
      customIcon={<PriceTagIcon className="w-24 h-24" />}
    >
      <div className="flex flex-col gap-8 p-2">
        <h3 className="">
          <Trans
            t={t}
            i18nKey="purchase:your_promo_code_has_been_added"
            values={{
              name: promoCode.toUpperCase(),
            }}
            components={{
              b: <span className="font-semibold text-primary-bold" />,
            }}
          />
        </h3>
        <p className="body-2">
          {t("purchase:promo_code_applied_modal_description")}
        </p>
      </div>

      <div className="flex justify-center w-full">
        <Modal.Buttons
          primaryButtonText={t("purchase:take_a_look")}
          onPrimaryClick={onClose}
        />
      </div>
    </Modal>
  ) : null;
};

export default PromoCodeAppliedModal;
